export var PACKAGE_JSON = { version: '5.3.1', package: '@fds/wm-typescript-mdg2-client' };
//# sourceMappingURL=version.js.map